import Axios from "axios";
import moment from "moment-timezone";
import { protectedResources } from "../authConfig";

let tokenKey;
export async function DashboardGraph(year) {
  const URL =
    protectedResources.apiHRMobile.baseApi +
    "/api/v1/UniformSurveyBackend/GetUniformSurveyRequestChart";
  if (
    typeof sessionStorage !== "undefined" &&
    sessionStorage.getItem("AccessToken") !== null
  ) {
    tokenKey = JSON.parse(sessionStorage.getItem("AccessToken")).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    year: year,
  };

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response;
  } catch (error) {
    // Silent fail
  }
}


export async function DashboardGraphCompare(site,year) {
  const URL =
    protectedResources.apiHRMobile.baseApi +
    "/api/v1/UniformSurveyBackend/GetUniformSurveySummary?site="+site+"&year="+year+"&lookingBackNYear=3";
  if (
    typeof sessionStorage !== "undefined" &&
    sessionStorage.getItem("AccessToken") !== null
  ) {
    tokenKey = JSON.parse(sessionStorage.getItem("AccessToken")).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {};

  try {
    const response = await Axios.get(URL, config);
    return await response;
  } catch (error) {
    // Silent fail
  }
}
